import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, useMediaQuery } from "@mui/material";

const getPositionStyles = (position) => {
  switch (position) {
    case "top-right":
      return { top: 0, right: 0, transform: "translate(-10%, 10%)" };
    case "top-left":
      return { top: 0, left: 0, transform: "translate(10%, 10%)" };
    case "bottom-right":
      return { bottom: 0, right: 0, transform: "translate(-10%, -10%)" };
    case "bottom-left":
      return { bottom: 0, left: 0, transform: "translate(10%, -10%)" };
    default:
      return {}; // Default position (centered)
  }
};

const CustomAlert = ({
  open,
  onClose,
  onConfirm,
  title,
  message,
  position = "center",
  titleColor = "",
  onCancel
}) => {
  const { i18n } = useTranslation();
  const isMobile = useMediaQuery("(max-width: 768px)");

  return (
    <Dialog
      sx={{
        minHeight: "400px",
      }}
      PaperProps={{
        style: {
          position: "absolute",
          ...getPositionStyles(position),
          borderRadius: "1vw",
        },
      }}
      open={open}
      onClick={()=>{
        if(onCancel){
          onCancel()
        }
        else{
          onClose()
        }
      }}
    >
      <Box sx={{ margin: "0.3vw 0.6vw -1.5vw auto !important" }}>
        <IconButton 
          onClick={()=>{
              if(onCancel){
                onCancel()
              }
              else{
                onClose()
              }
            }}>
          <CloseIcon />
        </IconButton>
      </Box>
      <DialogTitle
        sx={{
          textAlign: "center",
        }}
      >
        <div className={`${titleColor ? titleColor : ""}`}>{title}</div>
      </DialogTitle>
      <DialogContent
        sx={{
          textAlign: "center",
        }}
      >
        {message}
      </DialogContent>
      <DialogActions
        sx={{ marginBottom: "1vw", justifyContent: "space-evenly" }}
      >
        <Button
          sx={{ width: "40%", height: isMobile ? "" : "2.3vw" }}
          onClick={()=>{
            if(onCancel){
              onCancel()
            }
            else{
              onClose()
            }
          }}
          color="primary"
          variant="outlined"
        >
          {i18n.t("common.NO")}
        </Button>
        <Button
          sx={{ width: "40%", height:isMobile ? "" : "2.3vw"  }}
          onClick={onConfirm}
          color={titleColor === "text-danger" ? "error" : "primary"}
          variant="contained"
          autoFocus
        >
          {i18n.t("common.YES")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const useAlert = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [alertProps, setAlertProps] = useState({});

  const showAlert = (title, message, onConfirm, titleColor, onCancel) => {
    setAlertProps({ title, message, onConfirm, titleColor, onCancel});
    setIsOpen(true);
  };

  const closeAlert = () => {
    setIsOpen(false);
  };

  return {
    showAlert,
    CustomAlert: () => (
      <CustomAlert
        {...alertProps}
        open={isOpen}
        onClose={closeAlert}
        onConfirm={() => {
          closeAlert();
          if (alertProps.onConfirm) {
            alertProps.onConfirm();
          }
        }}
        onCancel={() => {
          closeAlert();
          if (alertProps.onCancel) {
            alertProps.onCancel();
          }
        }}

      />
    ),
  };
};

export default useAlert;
